import React from 'react';
import _ from 'lodash';
import { Route, Switch } from 'react-router';
import HelpTopic from 'HelpTopics';
import { useFilteredProtocolSetupRoutes } from 'acess/useCanViewProtocol';

const AppRoutesSwitch = ({ routes }) => {
  const filteredRoutes = useFilteredProtocolSetupRoutes(routes);

  return (
    <Switch>
      {filteredRoutes.map(({
        isExact, path, component: Component, helpContext = null
      }) => (
        helpContext ? <Route
          exact={isExact}
          path={path}
          render={() => {
            return <>
              <HelpTopic contextKey={helpContext} />
              <Component />
            </>
          }}
          key={_.uniqueId('route')}
        />
          :
          <Route
            exact={isExact}
            path={path}
            component={Component}
            key={_.uniqueId('route')}
          />
      ))}
    </Switch>
  );
};

export default AppRoutesSwitch;